import axios from "axios";
import { Modal, ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const ContractDeleteModal = ({
  isOpen,
  onClose,
  contract,
  token,
  API,
  onDeleted,
}) => {
  const { t } = useTranslation();

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${API}contract/delete/${contract._id}`,
        {
          headers: { authorization: `Bearer ${token}` },
        },
      );
      if (response.status === 200) {
        onDeleted?.();
        onClose();
        toast.success(t("The collection email has been successfully deleted"), {
          className: "custom-toast",
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error || t("Erreur lors de la suppression"),
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      modalClassName="settings-contact-modal"
      contentClassName="rounded-lg"
      centered
    >
      <ModalBody>
        <header className="settings-contact-modal__header">
          <h2 className="settings-contact-modal__title">
            {t("settingsContacts.deleteTitle")}
          </h2>
          <button
            type="button"
            className="settings-contact-modal__close"
            onClick={onClose}
            aria-label={t("Cancel")}
          >
            ×
          </button>
        </header>

        <p className="settings-contact-modal__text">
          {t("settingsContacts.deleteQuestion")}
        </p>
        <p className="settings-contact-modal__text">
          {t("settingsContacts.deleteConsequencesIntro")}
        </p>
        <ul className="settings-contact-modal__list">
          <li>{t("settingsContacts.deleteConsequence1")}</li>
          <li>{t("settingsContacts.deleteConsequence2")}</li>
          <li>{t("settingsContacts.deleteConsequence3")}</li>
        </ul>

        <div className="settings-contact-modal__footer">
          <button
            type="button"
            className="modal-button modal-button-cancel"
            onClick={onClose}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="modal-button modal-button-save"
            onClick={handleDelete}
          >
            {t("settingsContacts.deleteConfirmButton")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ContractDeleteModal;
